import { createContext } from '../../use-context-selector';
export const ApiContext = createContext(null);
//# sourceMappingURL=api-context.js.map